import { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';
import { StyledTableCellWithoutLeftRight } from 'routes/Main/style';
import Form from 'components/Form';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';

const contentLabel = [
  {
    id: 1,
    desc: [
      '지속적 심전도 모니터링: 지속적으로 심전도를 모니터링하고, 심전도 실시·평가 기록이 있는 경우',
      '호흡간호 - 흡인간호: 기관 내 삽관을 통한 흡인간호 또는 삽관 없는 흡인간호를 실시한 경우',
      '호흡간호 - 인공호흡기 사용: 인공호흡기 사용, NPPV 또는 가온 가습 고유량 비강캐뉼라 요법을 실시한 경우',
    ],
    scores: [1, 1, 1],
    ids: [1, 2, 3],
  },
  {
    id: 2,
    desc: [
      '호흡간호 - 비침습적산소투여: 비침습적 산소투여(비강캐뉼라, 산소마스크 등)를 시행한 경우',
      '정맥 내 투약: 정맥 내를 통해 투여하는 약품별 투여횟수의 합이 3회 이상/1일인 경우',
      '배액관 보유: 1개 이상 배액관을 보유하는 경우',
    ],
    scores: [1, 1, 1],
    ids: [4, 5, 6],
  },
  {
    id: 3,
    desc: [
      '욕창관리: 욕창드레싱 실시 또는 상태 확인한 경우',
      '수혈: 수혈을 실시한 경우',
      '전문치료 - 마약제(주사제): 통증 조절을 목적으로 마약제(주사제)를 투여한 경우',
    ],
    scores: [1, 1, 1],
    ids: [7, 8, 9],
  },
  {
    id: 4,
    desc: [
      '전문치료 - 항암치료제(주사제): 악성 종양 세포의 치료를 위해 항암치료제(주사제)를 투여한 경우',
      '전문치료 - 승압제(주사제): 쇼크, 저혈압, 순환허탈환자의 혈압을 상승시키기 위해 승압제(주사제)를 투여한 경우',
      '전문치료 - 항부정맥제(주사제): 부정맥 발생을 억제하기 위해 항부정맥제(주사제)를 투여한 경우',
      '전문치료 - 면역억제제(주사제): 거부반응방지를 위해 면역억제제(주사제)를 투여한 경우',
      '전문치료 - 항혈전제(정맥주사제): 혈전색전증 발생 및 발생이 의심되는 환자를 치료하기 위해 항혈전제를 정맥 내 투여한 경우',
    ],
    scores: [1, 1, 1, 1, 1],
    ids: [10, 11, 12, 13, 14],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Contents2 = (props: Props) => {
  const { palette } = useTheme();
  const { disabled, setValue, getValues, register } = props;

  const min = 0;
  const max = 1;

  const [input1, setInput1] = useState(
    getValues('no03_01') ? Number(getValues('no03_01')) : 0
  );
  const [input2, setInput2] = useState(
    getValues('no03_02') ? Number(getValues('no03_02')) : 0
  );
  const [input3, setInput3] = useState(
    getValues('no03_03') ? Number(getValues('no03_03')) : 0
  );
  const [input4, setInput4] = useState(
    getValues('no03_04') ? Number(getValues('no03_04')) : 0
  );
  const [input5, setInput5] = useState(
    getValues('no03_05') ? Number(getValues('no03_05')) : 0
  );
  const [input6, setInput6] = useState(
    getValues('no03_06') ? Number(getValues('no03_06')) : 0
  );
  const [input7, setInput7] = useState(
    getValues('no03_07') ? Number(getValues('no03_07')) : 0
  );
  const [input8, setInput8] = useState(
    getValues('no03_08') ? Number(getValues('no03_08')) : 0
  );
  const [input9, setInput9] = useState(
    getValues('no03_09') ? Number(getValues('no03_09')) : 0
  );
  const [input10, setInput10] = useState(
    getValues('no03_10') ? Number(getValues('no03_10')) : 0
  );
  const [input11, setInput11] = useState(
    getValues('no03_11') ? Number(getValues('no03_11')) : 0
  );
  const [input12, setInput12] = useState(
    getValues('no03_12') ? Number(getValues('no03_12')) : 0
  );
  const [input13, setInput13] = useState(
    getValues('no03_13') ? Number(getValues('no03_13')) : 0
  );
  const [input14, setInput14] = useState(
    getValues('no03_14') ? Number(getValues('no03_14')) : 0
  );

  return (
    <>
      <SectionTitle
        title="3. 측정항목 - A항목.간호활동 (코드번호로 기재)"
        mb={3}
        mt={3}
      />
      <Box sx={{ width: '98%', margin: '20px auto' }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCellWithoutLeftRight
                align="left"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                항목
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeftRight
                align="center"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    marginLeft: '-15px',
                  }}
                >
                  0: 적용기준 해당없음 <br />
                  1: 적용기준 해당함
                </Typography>
              </StyledTableCellWithoutLeftRight>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabel.map(
              (content: {
                id: number;
                desc: string[];
                scores: number[];
                ids: number[];
              }) => (
                <TableRow>
                  <StyledTableCellWithoutLeftRight>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '48px',
                          lineHeight: '48px',
                          borderBottom:
                            i !== content.desc.length - 1
                              ? '1px solid lightgray'
                              : '',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '16px',
                            fontSize: '12px',
                            width: '82.6vw',
                            maxWidth: '1340px',
                            minWidth: '1088px',
                            fontWeight: 500,
                          }}
                        >
                          {v}
                          <br />
                          {v === '가입자 구분 (코드번호로 기재)' && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                              }}
                            >
                              1. 건강보험 <br />
                              2. 의료급여 <br />
                              3. 산재보험 <br />
                              4. 자동차보험 <br />
                              5. 기타
                            </Typography>
                          )}

                          {v === '입퇴원여부 (코드번호로 기재)' && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                              }}
                            >
                              1. 재원 <br />
                              2. 입원(전입) <br />
                              3. 퇴원 <br />
                              4. 전출 <br />
                              5. 당일입퇴원 <br />
                              6. 외박(0시~24시 부재 시)
                            </Typography>
                          )}
                          {v ===
                            "상병코드: 주진단명에 해당하는 '한국표준질병사인분류'의 분류기호를 1개만 기재(예: C16.10)" && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                                marginTop: '-10px',
                                color: 'red',
                              }}
                            >
                              ※ 삼단분류까지 필수 기재(오단분류까지 기재 가능)
                            </Typography>
                          )}
                          {v ===
                            '당일수술여부(코드번호로 기재): 1: 수술 실시(수술 당일만), 2: 수술 미실시' && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                                marginTop: '-10px',
                                color: 'red',
                              }}
                            >
                              ※ 수술은 '건강보험 행위 급여·비급여 목록표 및 급여
                              상대가치 점수' 제9장, 제10장, 제18장의 항목 중
                              수술에 해당하는 분류항목
                            </Typography>
                          )}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRight>
                  <StyledTableCellWithoutLeftRight>
                    {content.scores.map((score, i) => {
                      return (
                        <TableRow
                          sx={{
                            height: '48px',
                            textAlign: 'center',
                            borderBottom:
                              i !== content.desc.length - 1
                                ? '1px solid lightgray'
                                : '',
                          }}
                        >
                          <Box
                            sx={{
                              width: '130px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Form.MuiTextField
                              disabled={disabled}
                              required={false}
                              type="number"
                              inputProps={{ min, max }}
                              value={
                                content.desc[i].includes(
                                  '지속적 심전도 모니터링'
                                )
                                  ? input1
                                  : content.desc[i].includes(String('흡인간호'))
                                  ? input2
                                  : content.desc[i].includes(
                                      String('인공호흡기 사용')
                                    )
                                  ? input3
                                  : content.desc[i].includes(
                                      String('비침습적산소투여')
                                    )
                                  ? input4
                                  : content.desc[i].includes(
                                      String('정맥 내 투약')
                                    )
                                  ? input5
                                  : content.desc[i].includes(
                                      String('배액관 보유:')
                                    )
                                  ? input6
                                  : content.desc[i].includes(
                                      String('욕창관리:')
                                    )
                                  ? input7
                                  : content.desc[i].includes(
                                      String('수혈을 실시한 경우')
                                    )
                                  ? input8
                                  : content.desc[i].includes(
                                      String('마약제(주사제)')
                                    )
                                  ? input9
                                  : content.desc[i].includes(
                                      String('항암치료제(주사제)')
                                    )
                                  ? input10
                                  : content.desc[i].includes(
                                      String('승압제(주사제)')
                                    )
                                  ? input11
                                  : content.desc[i].includes(
                                      String('항부정맥제(주사제)')
                                    )
                                  ? input12
                                  : content.desc[i].includes(
                                      String('면역억제제(주사제)')
                                    )
                                  ? input13
                                  : content.desc[i].includes(
                                      String('항혈전제(정맥주사제)')
                                    )
                                  ? input14
                                  : 0
                              }
                              {...register(
                                content.ids[i] < 10
                                  ? `no03_0${content.ids[i]}`
                                  : `no03_${content.ids[i]}`,
                                {
                                  onChange: e => {
                                    var value = parseInt(e.target.value, 10);

                                    let max = { score };

                                    if (value >= max.score) value = max.score;
                                    if (value < min) value = min;

                                    if (
                                      content.desc[i].includes(
                                        '지속적 심전도 모니터링'
                                      )
                                    )
                                      setInput1(value);
                                    else if (
                                      content.desc[i].includes('흡인간호')
                                    )
                                      setInput2(value);
                                    if (
                                      content.desc[i].includes(
                                        '인공호흡기 사용'
                                      )
                                    )
                                      setInput3(value);
                                    if (
                                      content.desc[i].includes(
                                        '비침습적산소투여'
                                      )
                                    )
                                      setInput4(value);
                                    if (
                                      content.desc[i].includes('정맥 내 투약:')
                                    )
                                      setInput5(value);
                                    if (
                                      content.desc[i].includes('배액관 보유:')
                                    )
                                      setInput6(value);
                                    if (content.desc[i].includes('욕창관리:'))
                                      setInput7(value);
                                    if (
                                      content.desc[i].includes(
                                        '수혈을 실시한 경우'
                                      )
                                    )
                                      setInput8(value);
                                    if (
                                      content.desc[i].includes('마약제(주사제)')
                                    )
                                      setInput9(value);
                                    if (
                                      content.desc[i].includes(
                                        '항암치료제(주사제)'
                                      )
                                    )
                                      setInput10(value);
                                    if (
                                      content.desc[i].includes('승압제(주사제)')
                                    )
                                      setInput11(value);
                                    if (
                                      content.desc[i].includes(
                                        '항부정맥제(주사제)'
                                      )
                                    )
                                      setInput12(value);
                                    if (
                                      content.desc[i].includes(
                                        '면역억제제(주사제)'
                                      )
                                    )
                                      setInput13(value);
                                    if (
                                      content.desc[i].includes(
                                        '항혈전제(정맥주사제)'
                                      )
                                    )
                                      setInput14(value);
                                  },
                                }
                              )}
                            />
                          </Box>
                        </TableRow>
                      );
                    })}
                  </StyledTableCellWithoutLeftRight>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            {/* 합계: {total}점 */}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Contents2;
